<template>
  <Modal
    :value="visible"
    title="申述评价·提交平台审核"
    width="723"
    :mask-closable="false"
    :footer-hide="true"
    class-name="appeal-review-modal"
    @on-cancel="handleClose"
  >
    <!-- ========== 评价信息卡片 ========== -->
    <div class="review-info-card">
      <div class="info-row">
        <span class="info-label">订单编号：</span>
        <span class="info-value">{{ commentDetail.ord.order_no || '-' }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">商品信息：</span>
        <span class="info-value">{{ commentDetail.product.name || '-' }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">用户信息：</span>
        <span class="info-value">{{ commentDetail.frommember.nickname || '-' }}（{{ commentDetail.frommember.blur_mobile || '-' }}）</span>
      </div>
      <div class="info-row">
        <span class="info-label">评价详情：</span>
        <span class="info-value">{{ commentDetail.content || '-' }}</span>
      </div>
      <!-- 评价图片 -->
      <div class="info-row info-row--images">
        <span class="info-label"></span>
        <div class="review-images">
          <div
            v-for="(img, index) in commentDetail.image_list"
            :key="index"
            class="image-thumb"
          >
            <img v-if="img.type === 'image'" v-viewer :src="img.raw | default_img" alt="评价图片" />
						<img v-if="img.type === 'video'" :src="`${img.raw}?x-oss-process=video/snapshot,t_2000,m_fast,ar_auto`" alt="评价视频" @click.stop="previewVideo(img.raw)" />
						<img v-if="img.type === 'video'" src="@/assets/images/icon-play-evaluate.png" class="video-icon" alt="视频图标" />
          </div>
        </div>
      </div>
      <div class="info-row">
        <span class="info-label">评论时间：</span>
        <span class="info-value">{{ commentDetail.create_time || '-' }}</span>
      </div>
    </div>

    <!-- ========== 举报原因 ========== -->
    <div class="section-block">
      <div class="section-title">
        举报原因<span class="required">*</span>
        <span class="section-subtitle">（提交后由平台人工审核）</span>
      </div>

      <RadioGroup v-model="selectedReason" vertical class="reason-group">
        <div
          v-for="item in reasonList"
          :key="item.value"
          class="reason-item"
          :class="{ 'reason-item--active': selectedReason === item.value }"
          @click="selectedReason = item.value"
        >
          <Radio :label="item.value" class="reason-radio">
            <span class="reason-label">{{ item.label }}</span>
          </Radio>
          <span class="reason-desc">{{ item.desc }}</span>
        </div>
      </RadioGroup>
    </div>

    <!-- ========== 补充说明 ========== -->
    <div class="section-block">
      <div class="section-title">补充说明（选填）</div>
      <Input
        v-model="supplementText"
        type="textarea"
        :rows="4"
        placeholder="可补充佐证说明，平台审核时将作为参考(不支持上传附件)"
        class="supplement-input"
      />
    </div>

    <!-- ========== 底部提示 ========== -->
    <div class="submit-tip">
      <img src="@/assets/images/ico_info.png" class="tip-icon" alt="提示图标" />
      提交后进入「审核中」，平台将在1-3个工作日内反馈结果，期间不可重复提交。
    </div>

		<div class="divider-row"></div>
    <!-- ========== 底部按钮 ========== -->
    <div class="modal-footer">
      <div class="btn-cancel" @click="handleClose">取消</div>
      <div type="error" class="btn-submit" @click="handleSubmit">提交平台审核</div>
    </div>
  </Modal>
</template>

<script>
import { SaveShopAppeal, UpdateShopAppeal, GetShopAppealDetail, GetShopCommentDetail } from '@/api/index.js';
import util from '@/utils/util.js';
import { mapState } from "vuex";

export default {
  name: 'AppealReviewModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    appeal_id: {
      type: Number,
      default: 0
    },
    comment_uuid: {
			type: String,
			default: ''
		}
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.getShopCommentDetail();
        this.getAppealDetail();
      }
    }
  },
  data() {
    return {
      selectedReason: '',
      supplementText: '',
      reasonList: [
        { value: 'malicious', label: '恶意差评', desc: '同行/敲诈/要挟' },
        { value: 'fake', label: '虚假评价', desc: '与事实严重不符' },
        { value: 'ad', label: '广告导流', desc: '含站外联系方式' },
        { value: 'abuse', label: '辱骂攻击', desc: '人身攻击/涉黄涉政' },
        { value: 'privacy', label: '泄露隐私', desc: '曝光他人信息' },
        { value: 'other', label: '其他违规', desc: '违反平台规则' }
      ],
      commentDetail: {
				frommember: {},
				image_list: [],
				product: {},
				ord: {},
			},
    };
  },
  methods: {
    getShopCommentDetail() {
			GetShopCommentDetail({
				uuid: this.comment_uuid
			}).then(res => {
				if (res.code === 0) {
					this.commentDetail = res.data;
				}
			});
		},
    getAppealDetail() {
      if (this.appeal_id) {
        GetShopAppealDetail({
          id: this.appeal_id
        }).then(res => {
          if (res.code === 0) {
            // this.selectedReason = res.data.reason;
            // this.supplementText = res.data.supplement;
          }
        });
      }
    },
    handleClose() {
      this.selectedReason = '';
      this.supplementText = '';
      this.$emit('update:visible', false);
      this.$emit('close');
    },
    handleSubmit() {
      if (!this.selectedReason) {
        this.$Message.warning('请选择举报原因');
        return;
      }
      const reasonObj = this.reasonList.find(item => item.value === this.selectedReason);
      if(this.appeal_id) {
        UpdateShopAppeal({
          id: this.appeal_id,
          appeal_content: reasonObj.label,
          appeal_description: reasonObj.desc,
          remark: this.supplementText
        }).then(res => {
          if (res.code === 0) {
            this.$Message.success('已重新提交平台审核');
            this.handleClose();
            this.$emit('confirm');
          }
        });
      } else {
        console.log('this.userInfo', this.userInfo);
        console.log('this.commentDetail.id', this.commentDetail.id);
        console.log('this.commentDetail.ord.order_id', this.commentDetail.ord.order_id);
        SaveShopAppeal({
          comment_id: this.commentDetail.id,
          appeal_content: reasonObj.label,
          appeal_description: reasonObj.desc,
          remark: this.supplementText,
        }).then(res => {
          if (res.code === 0) {
            this.$Message.success('已提交平台审核');
            this.handleClose();
            this.$emit('confirm');
          }
        });
      }
    },
    previewVideo(url) {
			util.previewVideo(url);
    },
  }
};
</script>

<style lang="scss" scoped>
/* ============================================
   评价信息卡片（灰底圆角区域）
   ============================================ */
.review-info-card {
  background: #F6F7F9;
  border-radius: 6px;
  padding: 16px 14px;
  margin-bottom: 20px;

  .info-row {
    display: flex;
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }

    &--images {
      align-items: flex-start;
    }

    .info-label {
			width: 70px;
      font-weight: 400;
			font-size: 14px;
			line-height: 21px;
			color: #666666;
			text-align: left;
			font-style: normal;
			text-transform: none;
			flex-shrink: 0;
    }

    .info-value {
      font-weight: 400;
			font-size: 14px;
			color: #333333;
			text-align: left;
			font-style: normal;
			text-transform: none;
      flex: 1;
      word-break: break-all;
    }
  }
}

/* 评价缩略图 */
.review-images {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;

  .image-thumb {
    position: relative;
		width: 54px;
		height: 54px;
		background: #D9D9D9;
		border-radius: 4px 4px 4px 4px;
		cursor: pointer;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .video-icon {
			position: absolute;
			top: 4px;
			right: 4px;
			width: 16px;
			height: 16px;
			object-fit: cover;
    }
  }
}

/* ============================================
   通用区块
   ============================================ */
.section-block {
  margin-bottom: 20px;
}

.section-title {
  font-weight: 500;
	font-size: 14px;
	line-height: 21px;
	color: #333333;
	text-align: left;
	font-style: normal;
	text-transform: none;
	margin-bottom: 10px;

  .required {
    color: #FF5967;
  }

  .section-subtitle {
    margin-left: 4px;
  }
}

/* ============================================
   举报原因 - 单选列表
   ============================================ */
.reason-group {
  width: 100%;
  display: block !important; // 覆盖 iView vertical 的 inline 样式
}

.reason-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #fff;

  &:last-child {
    margin-bottom: 0;
  }

  &:hover {
    border: 1px solid #FF5967;
    background: #FFECEE;
  }

  /* 选中态 - 红色边框 + 浅红背景 */
  &--active {
    border-color: #ed4014;
    background: #fff1f0;

    ::v-deep .ivu-radio-inner {
      border-color: #ed4014;

      &::after {
        background-color: #ed4014;
      }
    }
  }

  .reason-radio {
    ::v-deep .ivu-radio-wrapper {
      margin-right: 0;
    }
  }

  .reason-label {
		margin-left: 10px;
    font-weight: 400;
		font-size: 14px;
		line-height: 21px;
		color: #333333;
		text-align: left;
		font-style: normal;
		text-transform: none;
		flex-shrink: 0;
  }

  .reason-desc {
    font-weight: 400;
		font-size: 14px;
		line-height: 21px;
		color: #999999;
		text-align: right;
		font-style: normal;
		text-transform: none;
    flex-shrink: 0;
  }
}

/* ============================================
   补充说明
   ============================================ */
.supplement-input {
  ::v-deep .ivu-input {
    border-radius: 6px;
		padding: 12px 16px;
		font-weight: 400;
		font-size: 14px;
		line-height: 21px;
		color: #333333;
		text-align: left;
		font-style: normal;
		text-transform: none;

    &::placeholder {
      color: #B3B3B3;
    }
  }
}

/* ============================================
   底部提示文字
   ============================================ */
.submit-tip {
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 400;
	font-size: 12px;
	line-height: 18px;
	color: #999999;
	text-align: left;
	font-style: normal;
	text-transform: none;
  margin-bottom: 24px;

  .tip-icon {
    width: 14px;
    height: 14px;
    object-fit: cover;
		margin-right: 6px;
  }
}
.divider-row {
	margin: 0 -24px 12px -24px;
	height: 1px;
	background: #e0e0e0;
}
/* ============================================
   底部按钮栏
   ============================================ */
.modal-footer {
  display: flex;
  justify-content: center;
  gap: 10px;

  .btn-cancel {
		display: flex;
		justify-content: center;
		align-items: center;
    width: 100px;
		height: 40px;
		background: #FFFFFF;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #E3E3E3;
		cursor: pointer;

		font-weight: bold;
		font-size: 14px;
		line-height: 21px;
		color: #666666;
		text-align: center;
		font-style: normal;
		text-transform: none;

  }

  .btn-submit {
		display: flex;
		justify-content: center;
		align-items: center;
    width: 120px;
		height: 40px;
		background: #FF5967;
		border-radius: 4px 4px 4px 4px;
		cursor: pointer;

		font-weight: bold;
		font-size: 14px;
		line-height: 21px;
		color: #FFFFFF;
		text-align: center;
		font-style: normal;
		text-transform: none;
  }
}
</style>

<!-- 全局样式：覆盖 iView Modal 默认样式 -->
<style lang="scss">
.appeal-review-modal {
  .ivu-modal {
    top: 40px;
  }

  .ivu-modal-header {
    padding: 18px 24px 12px 24px;
    border-bottom: 1px solid #e0e0e0;

    .ivu-modal-header-inner {
      font-weight: bold;
			font-size: 18px;
			line-height: 27px;
			color: #0F1115;
			text-align: center;
			font-style: normal;
			text-transform: none;
    }
  }

  .ivu-modal-body {
    padding: 12px 24px 24px !important;
    text-align: left;
  }

  .ivu-modal-close {
    top: 16px;
    right: 16px;

    .ivu-icon {
      font-size: 18px;
      color: #999;

      &:hover {
        color: #333;
      }
    }
  }

  /* 隐藏默认 footer（我们自定义了） */
  .ivu-modal-footer {
    display: none;
  }
}
</style>